{
  "es": {
    "pagination": {
      "next": "Página siguiente",
      "page_report": "Página {page} de {total}",
      "previous": "Página anterior",
      "report": "Mostrando {first} a {last} de {total}",
      "total": "Total de elementos: {total}"
    }
  }
}
